var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"target",style:({ minHeight: _vm.isIntersecting ? 'auto' : `${_vm.placeholderHeight}px` })},[(_vm.isIntersecting)?_vm._t("default"):_c('div',{staticClass:"d-flex justify-center align-center",style:({ height: `${_vm.placeholderHeight}px` })},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }